export default __webpack_public_path__ + "static/media/LearningExl.6842614e.xlsx";